import React, {type FC} from "react";
import { useDispatch } from "react-redux";
import { useShallowPickSelector } from "store/useSelector";
import { appActions } from "store/app/app.slice";
import { Button, Stack, Typography,  } from "@mui/material";
import { BottomSheet } from "components/atoms/BottomSheet";
import { ReactComponent as AppleSVG } from "assets/images/apple.svg";
import { ReactComponent as AndroidSVG } from "assets/images/android.svg";
import { ReactComponent as GooglePlaySVG } from "assets/images/googleplay.svg";
import { ReactComponent as DownloadSVG } from "assets/images/download.svg";

export const DownloadApplicationMenu: FC = () => {
  const { downloadApplicationMenu } = useShallowPickSelector("app", ["downloadApplicationMenu"]);

  const dispatch = useDispatch();

  const onClose = () => {
    if(!downloadApplicationMenu.isCloseable) return;
    dispatch(appActions.setDownloadApplicationMenu({ isOpen: false, isCloseable: true }));
  }

  return (
    <BottomSheet isOpen={downloadApplicationMenu.isOpen} onClose={onClose} Title={
      <Stack p="1rem" direction="row-reverse" alignItems="center" spacing=".5rem">
        <DownloadSVG />
        <Typography fontSize={"1.1rem"} fontWeight={700}>
          دانلود اپلیکیشن آواگپ
        </Typography>
      </Stack>
    }>
      <Stack px="1.5rem" alignItems="flex-end" py=".5rem" spacing={2}>
        <Stack direction="row-reverse" alignItems="center" justifyContent="center" textAlign="right" spacing=".2rem">
          <Typography fontSize=".8rem" fontWeight={700} dir="rtl">
            اپلیکیشن آواگپ را متناسب با سیستم عامل خود نصب نمایید
          </Typography>
        </Stack>
        <Stack mx={5} my={5} alignSelf={"stretch"} spacing={1}>
          <a href="https://avagap.com/avagap-release-1.1.15.apk">
            <Button variant={"contained"} fullWidth onClick={onClose}>
              <Stack direction="row" spacing={2}>
                <AndroidSVG />
                <span>دانلود مستقیم مخصوص اندروید</span>
              </Stack>
            </Button>
          </a>
        </Stack>
        <Stack mx={5} my={5} alignSelf={"stretch"} spacing={1}>
          <a href="https://play.google.com/store/apps/details?id=io.soundmatch.avagap&pli=1">
            <Button variant={"contained"} fullWidth onClick={onClose}>
                <Stack direction="row" spacing={2}>
                  <GooglePlaySVG style={{height: 25}} />
                  <span>دانلود از گوگل پلی</span>
                </Stack>
            </Button>
            </a>
        </Stack>
        <Stack mx={5} my={5} alignSelf={"stretch"} spacing={1}>
          <a href="https://pwa.avagap.com/">
            <Button variant={"contained"} fullWidth onClick={onClose}>
              <Stack direction="row" spacing={5}>
                <AppleSVG />
                <span>نسخه وب مخصوص آیفون</span>
              </Stack>
            </Button>
          </a>
        </Stack>
      </Stack>
    </BottomSheet>
  );
};
